<!-- 予約状況編集画面 予約状況編集 -->
<!--<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>-->
<style src="@/assets/css/admin_parts_main.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/admin_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/admin_parts_confirm.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_course.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>

<style scoped></style>
<template>
	<div class="contents" id="wiga1Detail">
		<h2>予約状況編集</h2>
		<ul class="contntMenu">
			<li class="onCancel" v-on:click="onCancel">キャンセル</li>
		</ul>
		<section id="mainContent">
			<section class="inputArea">
			  <!-- 予約状況入力欄 -->
			  <h3>予約状況入力欄</h3>
				<div class="btnLst">
					<button class="confBtn" v-on:click="onChangeReserveInfoConfirmModalOpen">更新</button>
				</div>
				<section class="inputTbl">
					<dl>
						<dt>ステータス</dt>
						<dd>
							<select v-model="inputForm.statusCode">
								<option v-for="item in inputForm.statusList" v-bind:value="item.code" v-bind:key="item.code">
									{{item.displayValue}}
								</option>
							</select>
							<label for="isSendMailCheckbox" class="checkbox"><input type="checkbox" name="isSendMailCheckboxGroup" id="isSendMailCheckbox" v-model="inputForm.isSendMail"><span>更新時にメールを送信する</span></label>
						</dd>
					</dl>
					<dl class="date">
						<dt>受診日</dt>
						<dd>
						  <!--
							<ul><li>{{inputForm.reserveDateYear}}</li><li>{{inputForm.reserveDateMonth}}</li><li>{{inputForm.reserveDateDate}}</li>
                <li v-if="inputForm.krkb=='2'"><b>受診予定時間</b>{{getSthm}}</li>
							</ul>
							-->
				      <ul class="dayForm">
                <li>
                  <select v-model="inputForm.reserveDateYear">
                    <option value=0>選択</option>
                    <option v-for="item in inputForm.reserveYearList" v-bind:key="item">
                      {{item}}
                    </option>
                  </select>
                </li>
                <li>
                  <select v-model="inputForm.reserveDateMonth">
                    <option value=0>選択</option>
                    <option v-for="item in inputForm.reserveYearMonth" v-bind:key="item">
                      {{item}}
                    </option>
                  </select>
                </li>
                <li>
                  <select v-model="inputForm.reserveDateDate">
                    <option value=0>選択</option>
                    <option v-for="item in computedReserveDateList" v-bind:key="item">
                      {{item}}
                    </option>
                  </select>
                </li>
				      	<li v-if="inputForm.krkb=='2'">
				      		<b>受診予定時間</b>
                  <select v-model="inputForm.reserveTmzn">
                    <option value="">選択</option>
                    <option v-for="item in inputForm.tmznList" v-bind:value="item.tmzn" v-bind:key="item.tmzn">
                      {{item.sthm}}
                    </option>
                  </select>
				      	</li>
              </ul>
							<button class="confBtn" v-on:click="onToCalender">カレンダー</button>
						</dd>
					</dl>
				</section>
			</section>
			<section class="confirmArea">
				<!-- 予約登録詳細欄 -->
				<h3>予約情報詳細</h3>
				<!-- 予約情報 -->
				<section class="reservation">
					<h3 class="ukNo"><span>予約番号</span>{{detail.ukno}}</h3>
					<ul class="date">
						<li>{{detail.reserveDateYear}}<!--年--></li>
						<li>{{detail.reserveDateMonth}}<!--月--></li>
						<li>{{detail.reserveDateDate}}<!--日--></li>
						<li v-if="inputForm.krkb=='2'">{{detail.reserveSthm}}<!--時間--></li>
					</ul>
					<!-- 選択コース詳細 -->
					<div class="course">
						<h4>{{detail.courseInfo.ksnm}}</h4>
						<dl class="item">
							<dt>検査項目</dt>
							<dd>
								<ul>
									<li v-for="item in detail.courseInfo.listInspection" v-bind:key="item.kmnm" v-bind:class="getBackendColorInspectionJskb(item.jskb)">
										<span>{{item.kmnm}}</span>
									</li>
								</ul>
							</dd>
						</dl>
						<div class="fBox">
							<div class="plan">
								<p class="time"><span>所要時間</span>{{detail.courseInfo.time}}</p>
								<p class="note">
									{{detail.courseInfo.mem1}}
								</p>
								<dl class="target">
									<dt>この検査を受けて欲しい方</dt>
									<dd>{{detail.courseInfo.mem2}}</dd>
								</dl>
								<dl class="option">
									<dt>追加オプション</dt>
									<dd>
										<ul>
											<li v-for="item in detail.optionInfoList" v-bind:key="item.opnm">
												{{item.opnm}}
											</li>
										</ul>
									</dd>
								</dl>
							</div>
							<!-- 料金明細 -->
							<div class="price">
								<h4>料金明細</h4>
								<p class="base">
									{{detail.courseInfo.ksnm}}
										<em v-if="detail.kshj=='1'">
											{{detail.courseInfo.gkgk | moneyDelimiter}}
											<span v-if="detail.taxk=='1'">（税抜）</span>
											<span v-else>（税込）</span>
										</em>
								</p>
								<ul>
									<li v-for="item in detail.optionInfoList" v-bind:key="item.opnm">
										{{item.opnm}}
										<div v-if="detail.kshj=='1'">
											<em>
												{{item.gkgk | moneyDelimiter}}
												<span v-if="detail.taxk=='1'">（税抜）</span>
												<span v-else>（税込）</span>
											</em>
										</div>
									</li>
								</ul>
								<p class="total">
									合計金額
									<b>
										{{detail.sumGkgk | moneyDelimiter}}
										<span v-if="detail.taxk=='1'">（税抜）</span>
										<span v-else>（税込）</span>
									</b>
								</p>
							</div>
						</div>
					</div>
				</section>
				<!-- 個人情報 -->
				<section class="personalDataTbl">
					<dl v-if="detail.jgcdIsDisplay">
						<dt>健康保険組合名</dt>
						<dd>{{detail.jgnm}}</dd>
					</dl>
					<dl v-if="detail.hkshIsDisplay">
						<dt>保険者番号</dt>
						<dd>{{detail.hksh}}</dd>
					</dl>
          <dl>
            <dt>保険証記号</dt>
            <dd>{{detail.hkkg}}</dd>
          </dl>
          <dl>
            <dt>保険証番号</dt>
            <dd>{{detail.hkno}}</dd>
          </dl>
					<dl v-if="detail.hfkbIsDisplay">
						<dt>対象者区分</dt>
						<dd>{{detail.kbnm}}</dd>
					</dl>
					<dl v-if="detail.cmnmIsDisplay">
						<dt>企業名</dt>
						<dd>{{detail.cmnm}}</dd>
					</dl>
					<!-- 雲財修正2 -->
					<dl class="name">
						<dt>氏名</dt>
						<dd>
							<ul>
								<li v-if="detail.ryk1IsDisplay&&detail.ryk2IsDisplay"><span>カタカナ</span>{{detail.ryak}}</li>
								<li v-if="detail.nam1IsDisplay&&detail.nam2IsDisplay"><span>漢字</span>{{detail.name}}</li>
							</ul>
						</dd>
					</dl>
					<dl class="birthday" v-if="detail.btdyYearIsDisplay&&detail.btdyMonthIsDisplay&&detail.btdyDateIsDisplay">
						<dt>生年月日</dt>
						<dd><ul><li>{{detail.btdyYear}}</li><li>{{detail.btdyMonth}}</li><li>{{detail.btdyDate}}</li></ul></dd>
					</dl>
					<dl class="age" v-if="detail.ageIsDisplay">
						<dt>年齢</dt>
						<dd><span>受診日時点での年度年齢</span><b>{{detail.age}}</b></dd>
					</dl>
					<dl v-if="detail.sexIsDisplay">
						<dt>性別</dt>
						<dd>
							{{computedStrSex}}
						</dd>
					</dl>
					<dl class="add" v-if="detail.zip1IsDisplay&&detail.zip2IsDisplay&&detail.adr1IsDisplay&&detail.adr2IsDisplay">
						<dt>ご住所</dt>
						<dd>
							<ul>
								<li class="zip">{{detail.zip}}</li>
								<li>{{computedStrAddr}}</li>
							</ul>
						</dd>
					</dl>
					<dl class="add" v-if="detail.tel1IsDisplay">
						<dt>電話番号</dt>
						<dd class="tel">{{detail.tel1}}</dd>
					</dl>
					<dl v-if="detail.synoIsDisplay">
						<dt>社員番号</dt>
						<dd>{{detail.syno}}</dd>
					</dl>
					<dl v-if="detail.dmkbIsDisplay">
						<dt>ＤＭ・メルマガ</dt>
						<dd>{{computedStrDmkb}}</dd>
					</dl>
					<dl v-if="detail.mem1IsDisplay">
						<dt>備考</dt>
						<dd>{{detail.mem1}}</dd>
					</dl>
				</section>
			</section>
		</section>
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.changeReserveInfoStart.isShow" v-on:close="onChangeReserveInfoStartModalClose">
			<dt slot="modal-header">予約状況変更処理中</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.changeReserveInfoStart.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.changeReserveInfoConfirm.isShow" v-on:close="onChangeReserveInfoConfirmModalClose">
			<dt slot="modal-header">予約状況変更確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.changeReserveInfoConfirm.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer">
				<button class="cancelBtn" v-on:click="onUpdate">変更する</button>
				<button class="backBtn" v-on:click="onChangeReserveInfoConfirmModalClose">閉じる</button>
			</dd>
		</modalWindow>
		<!-- モーダルWindow S -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { WIGA1DetailApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'WIGA1Detail',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }

        return value.toLocaleString()
      }
    },
		// 算出プロパティ
		computed: {
			// 表示時間帯を取得
			getSthm: function () {
				var result = ''

				// 時間帯がZZの場合（日枠の場合）は空文字を返す
				if('ZZ' == this.inputForm.reserveTmzn) {
					return result
				}

				var obj = this.inputForm.tmznList.find(
					item => item.tmzn == this.inputForm.reserveTmzn)

				if(obj!=null) {
					result = obj.sthm
				}

				return result
			},
			// 性別 表示用文字列を取得
			computedStrSex: function() {

				var result = ''

				if(this.detail.codeSexMan == this.detail.sex) {
					result = '男性'
				} else if(this.detail.codeSexWoman == this.detail.sex) {
					result = '女性'
				}

				return result
			},
			// 住所 表示用文字列を取得
			computedStrAddr: function() {

				var result = ''

				if('' == this.detail.adr1 || '' == this.detail.adr2 ){
					return result
				}

				result = this.detail.adr1 + this.detail.adr2

				if('' != this.detail.adr3 && this.detail.adr3IsDisplay){
					result += this.detail.adr3
				}

				return result
			},
			// ＤＭ・メルマガ 表示用文字列を取得
			computedStrDmkb: function() {

				var result = ''

				if(this.detail.codeDmkbNG == this.detail.dmkb) {
					result = '受け取らない'
				} else if(this.detail.codeDmkbOK == this.detail.dmkb) {
					result = '受け取る'
				}

				return result
			},
      // 生年月日　日付のプルダウン内容を生成
      computedReserveDateList: function () {

        var tempListBtdyDate = []

        // 当月の最終日の求め方
        // 本来8月なら第二引数（月）は7を与えるべきだが
        // 本来8月なら第三引数（日）に0を与えて
        // 次月の最初の日（1日）より一日前（0日）で
        // 当月の最終日を求める
        var lastDate = new Date(
          this.inputForm.reserveDateYear,
          this.inputForm.reserveDateMonth, 0).getDate()

        for (var i = 1; i <= lastDate; i++) {
          tempListBtdyDate.push(i)
        }

        return tempListBtdyDate
      }
		},
		// データ
		data() {
			return {
				// 入力欄
				inputForm: {

					// ステータスリスト
					// code: ステータスコード('21'、'22'、'23'、'91'、'92'、'99')
					// displayValue: ステータス画面表示
					statusList: [
						{
							code: '21',
							displayValue: '予約済（新規　確認未）'
						},
						{
							code: '22',
							displayValue: '予約済（変更　確認未）'
						},
						{
							code: '23',
							displayValue: '予約済（確認済）'
						},
						{
							code: '91',
							displayValue: 'キャンセル済（確認未）'
						},
						{
							code: '92',
							displayValue: 'キャンセル済（確認済）'
						},
						{
							code: '99',
							displayValue: 'キャンセル済（削除済）'
						},
					],

					// ステータスコード
					statusCode: '',

					// メール送信するかどうか
					// true: 送信する
					// false: 送信しない
					isSendMail: false,

					// 受診日（予約日） 年月日
					reserveDateYear: 0,
					reserveDateMonth: 0,
					reserveDateDate: 0,
          // 受診日（予約日）　年のプルダウン内容
          reserveYearList:[],
          // 受診日（予約日）　月のプルダウン内容
          reserveYearMonth: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
          ],

					// 枠管理区分
					// 1: 日枠
					// 2: 時間帯枠
					krkb: '',

					// 受診（予約）時間帯コード
					reserveTmzn: '',

					// 時間帯リスト
					// tmzn: 時間帯コード
					// sthm: 表示用（HH:MM）
					tmznList: [],
				},
				// ユーザータイプ
				userType: '2',
				// 予約確認画面と同じロジックで実装
				// 2: マイページ経由かつ予約変更（個人）
				codeUserTypeMyPageChangeIndividual: '2',
				// 3: マイページ経由かつ予約変更（健保）
				codeUserTypeMyPageChangeHealth: '3',

				// 表示項目
				detail: {

					// 消費税区分
					// 1: 外税 税抜
					// 2: 内税 税込
					taxk: '',

					// 金額表示
					// 0:非表示 1:表示
					kshj: '',

					// 予約受付番号
					ukno: '',

					// 予約日付
					// 年
					reserveDateYear: 0,
					// 月
					reserveDateMonth: 0,
					// 日
					reserveDateDate: 0,
					// 予約時間帯　開始時間表示名
					reserveSthm: '',

					// コース情報
					// ksnm コース名
					// time 経過時間
					// kngk 金額
					// gkgk 消費税込み金額
					// listInspection: 検査項目リスト
					//  kmnm: 検査項目名
					//  jskb: 受診区分
					courseInfo: {
						ksnm: '',
						time: '',
						mem1: '',
						mem2: '',
						gkgk: 0,
						listInspection: [
							{
								ksnm: '',
								jskb: ''
							}
						]
					},

					// gkgk: 合計金額
					optionInfoList: [],
					// 合計消費税込み金額
					sumGkgk: 0,

					// 健康保険組合名（クライアント名）
					jgnm: '',
					// 保険者番号
					hksh: '',
					// 保険証記号
					hkkg: '',
					// 保険証番号
					hkno: '',
					// 対象者区分名
					kbnm: '',
					// 企業名
					cmnm: '',
					// 漢字氏名
					name: '',
					// カナ氏名
					ryak: '',
					// 生年月日　年
					btdyYear: 0,
					// 生年月日　月
					btdyMonth: 0,
					// 生年月日　日付
					btdyDate: 0,
					// 年齢
					age: 0,
					// 性別の選択値 1:男、2:女
					sex: '',
					// 性別 男のコード値
					codeSexMan: '1',
					// 性別 女のコード値
					codeSexWoman: '2',
					// ご住所
					// 郵便番号
					zip: '',
					// 都道府県
					adr1: '',
					// 住所１（市区町村）
					adr2: '',
					// 住所２（番地）
					adr3: '',
					// 電話番号（日中連絡先）
					tel1: '',
					// 社員番号
					syno: '',
					// メールアドレス
					email: '',
					// ＤＭ・メルマガ 0:受け取らない、1:受け取る
					dmkb: '',
					// ＤＭ・メルマガ 受け取らないのコード値
					codeDmkbNG: '0',
					// ＤＭ・メルマガ 受け取るのコード値
					codeDmkbOK: '1',
					// 備考
					mem1: '',

					// 健康保険組合名
					// 表示非表示フラグ
					jgcdIsDisplay: false,
					// 保険者番号
					hkshIsDisplay: false,
					// 保険証記号
					hkkgIsDisplay: false,
					// 保険証番号
					hknoIsDisplay: false,
					// 対象者区分
					hfkbIsDisplay: false,
					// 企業名
					cmnmIsDisplay: false,
					// 漢字氏名
					// 姓
					nam1IsDisplay: false,
					// 名
					nam2IsDisplay: false,
					// カナ氏名
					// 姓
					ryk1IsDisplay: false,
					// 名
					ryk2IsDisplay: false,
					// 生年月日
					// 年
					btdyYearIsDisplay: false,
					// 月
					btdyMonthIsDisplay: false,
					// 日
					btdyDateIsDisplay: false,
					// 年齢
					ageIsDisplay: false,
					// 性別
					sexIsDisplay: false,
					// ご住所
					// 郵便番号 前半
					zip1IsDisplay: false,
					// 郵便番号 後半
					zip2IsDisplay: false,
					// 都道府県
					adr1IsDisplay: false,
					// 住所１（市区町村）
					adr2IsDisplay: false,
					// 住所２（番地）
					adr3IsDisplay: false,
					// 電話番号
					tel1IsDisplay: false,
					// 社員番号
					synoIsDisplay: false,
					// メールアドレス
					emailIsDisplay: false,
					// ＤＭ・メルマガ
					dmkbIsDisplay: false,
					// 備考
					mem1IsDisplay: false,
				},
				// モーダルウィンドウ
				modal: {
					// 予約状況変更処理中
					changeReserveInfoStart: {
						messages: [
							'予約状況を変更中です。'
						],
						isShow: false
					},
					// 予約状況変更確認
					changeReserveInfoConfirm: {
						messages: [
							'予約状況を変更します。'
						],
						isShow: false
					},
					// 入力エラーダイアログ
					validationError: {
						messages: [],
						isShow: false
					},
					// システムエラーダイアログ
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					}
				}
			}
		},
		created: function() {

			UtilityConsoleLog.consoleLog('WIGA1Detail::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('WIGA1Detail::created End')
		},
		methods: {
			// 表示系--------------------------------------------------S
			// 初期表示
			firstDisplay: function () {

				UtilityConsoleLog.consoleLog('WIGA1Detail::firstDisplay Start')

				WIGA1DetailApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					ukno: this.$store.state.adminUserChoice.MasterWIGA1.ukno
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// レスポンスを受け取る
						// 予約状況入力欄
						this.inputForm.statusCode = responce.data.statusCode
						this.inputForm.krkb = responce.data.krkb

						this.inputForm.tmznList = responce.data.tmznList

						this.inputForm.reserveYearList = responce.data.reserveYearList

						// 予約状況編集カレンダーで予約変更日（と時間帯）を選択している場合
						if(this.$store.state.adminUserChoice.MasterWIGA1.changeDateFlag) {
							this.inputForm.reserveDateYear = this.$store.state.adminUserChoice.MasterWIGA1.changeDateYear
							this.inputForm.reserveDateMonth = this.$store.state.adminUserChoice.MasterWIGA1.changeDateMonth
							this.inputForm.reserveDateDate = this.$store.state.adminUserChoice.MasterWIGA1.changeDateDate
							this.inputForm.reserveTmzn = this.$store.state.adminUserChoice.MasterWIGA1.changeDateTmzn
						} else {
							this.inputForm.reserveDateYear = responce.data.reserveDateYear
							this.inputForm.reserveDateMonth = responce.data.reserveDateMonth
							this.inputForm.reserveDateDate = responce.data.reserveDateDate
							this.inputForm.reserveTmzn = responce.data.reserveTmzn
						}

						// 予約登録詳細欄
						// クライアントコード
						var tempJgcd = ""

						// レスポンスからデータ取得
						this.detail.ukno = this.$store.state.adminUserChoice.MasterWIGA1.ukno
						this.detail.taxk = responce.data.taxk
						this.detail.kshj = responce.data.kshj
						this.detail.reserveDateYear = responce.data.reserveDateYear
						this.detail.reserveDateMonth = responce.data.reserveDateMonth
						this.detail.reserveDateDate = responce.data.reserveDateDate
						this.detail.reserveSthm = responce.data.reserveSthm
						this.detail.courseInfo = responce.data.courseInfo
						this.detail.optionInfoList = responce.data.optionInfoList
						this.detail.sumGkgk = responce.data.sumGkgk
						tempJgcd = responce.data.jgcd
						this.detail.jgnm = responce.data.jgnm
						this.detail.hksh = responce.data.hksh
						this.detail.hkkg = responce.data.hkkg
						this.detail.hkno = responce.data.hkno
						this.detail.kbnm = responce.data.kbnm
						this.detail.cmnm = responce.data.cmnm
						this.detail.name = responce.data.name
						this.detail.ryak = responce.data.ryak
						this.detail.btdyYear = responce.data.btdyYear
						this.detail.btdyMonth = responce.data.btdyMonth
						this.detail.btdyDate = responce.data.btdyDate
						this.detail.age = responce.data.age
						this.detail.sex = responce.data.sex
						this.detail.zip = responce.data.zip
						this.detail.adr1 = responce.data.adr1
						this.detail.adr2 = responce.data.adr2
						this.detail.adr3 = responce.data.adr3
						this.detail.tel1 = responce.data.tel1
						this.detail.syno = responce.data.syno
						this.detail.email = responce.data.emal
						this.detail.dmkb = responce.data.dmkb
						this.detail.mem1 = responce.data.mem1

						// ユーザータイプを決める
						this.userType = this.getUserType(
							tempJgcd
						)

						// ユーザータイプによってそれぞれ初期設定
						// （表示非表示）を行う
						this.setInitializeValue()

						// ストア値の更新
						this.$store.commit(
							types.ADMIN_USERCHOICE_WIGA1DETAIL_FIRSTDISPLAY)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1Detail::firstDisplay End')
				})
			},
			// ストア値などからユーザータイプを取得
			getUserType: function(in_jgcd) {

				UtilityConsoleLog.consoleLog('CommonConfirmCancel::getUserType Start')

				var resultUserType = ''

				// 個人か健保かどうか
				if('00000000' == in_jgcd) {
					// 個人
					resultUserType = this.codeUserTypeMyPageChangeIndividual
				} else {
					// 健保
					resultUserType = this.codeUserTypeMyPageChangeHealth
				}

				UtilityConsoleLog.consoleLog('CommonConfirmCancel::getUserType End')

				return resultUserType
			},
			// ユーザータイプによって初期化関数を呼び出す
			setInitializeValue: function () {
				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValue Start')

				if(this.codeUserTypeMyPageChangeIndividual == this.userType) {
					// 2: マイページ経由かつ予約変更（個人）
					this.setInitializeValueMyPageChangeIndividual()
				} else if(this.codeUserTypeMyPageChangeHealth == this.userType) {
					// 3: マイページ経由かつ予約変更（健保）
					this.setInitializeValueMyPageChangeHealth()
				}

				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValue End')
			},
			// 2: マイページ経由かつ予約変更（個人）時の各項目初期化
			setInitializeValueMyPageChangeIndividual: function() {
				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeIndividual Start')

				// 健康保険組合名
				this.detail.jgcdIsDisplay = true

				// 保険者番号
				this.detail.hkshIsDisplay = false

				// 保険証記号
				this.detail.hkkgIsDisplay = true

				// 保険証番号
				this.detail.hknoIsDisplay = true

				// 対象者区分
				this.detail.hfkbIsDisplay = true

				// 企業名
				this.detail.cmnmIsDisplay = true

				// 漢字氏名
				// 姓
				this.detail.nam1IsDisplay = true
				// 名
				this.detail.nam2IsDisplay = true

				// カナ氏名
				// 姓
				this.detail.ryk1IsDisplay = true
				// 名
				this.detail.ryk2IsDisplay = true

				// 生年月日
				// 年
				this.detail.btdyYearIsDisplay = true
				// 月
				this.detail.btdyMonthIsDisplay = true
				// 日
				this.detail.btdyDateIsDisplay = true

				// 年齢
				this.detail.ageIsDisplay = true

				// 性別
				this.detail.sexIsDisplay = true

				// ご住所
				// 郵便番号 前半
				this.detail.zip1IsDisplay = true
				// 郵便番号 後半
				this.detail.zip2IsDisplay = true
				// 都道府県
				this.detail.adr1IsDisplay = true
				// 住所１（市区町村）
				this.detail.adr2IsDisplay = true
				// 住所２（番地）
				this.detail.adr3IsDisplay = true

				// 電話番号
				this.detail.tel1IsDisplay = true

				// 社員番号
				this.detail.synoIsDisplay = true

				// メールアドレス
				this.detail.emailIsDisplay = true

				// ＤＭ・メルマガ
				this.detail.dmkbIsDisplay = true

				// 備考
				this.detail.mem1IsDisplay = true

				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeIndividual End')
			},
			// 3: マイページ経由かつ予約変更（健保）時の各項目初期化
			setInitializeValueMyPageChangeHealth: function() {
				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeHealth Start')

				// 健康保険組合名
				this.detail.jgcdIsDisplay = true

				// 保険者番号
				this.detail.hkshIsDisplay = true

				// 保険証記号
				this.detail.hkkgIsDisplay = true

				// 保険証番号
				this.detail.hknoIsDisplay = true

				// 対象者区分
				this.detail.hfkbIsDisplay = true

				// 企業名
				this.detail.cmnmIsDisplay = true

				// 漢字氏名
				// 姓
				this.detail.nam1IsDisplay = true
				// 名
				this.detail.nam2IsDisplay = true

				// カナ氏名
				// 姓
				this.detail.ryk1IsDisplay = true
				// 名
				this.detail.ryk2IsDisplay = true

				// 生年月日
				// 年
				this.detail.btdyYearIsDisplay = true
				// 月
				this.detail.btdyMonthIsDisplay = true
				// 日
				this.detail.btdyDateIsDisplay = true

				// 年齢
				this.detail.ageIsDisplay = true

				// 性別
				this.detail.sexIsDisplay = true

				// ご住所
				// 郵便番号 前半
				this.detail.zip1IsDisplay = true
				// 郵便番号 後半
				this.detail.zip2IsDisplay = true
				// 都道府県
				this.detail.adr1IsDisplay = true
				// 住所１（市区町村）
				this.detail.adr2IsDisplay = true
				// 住所２（番地）
				this.detail.adr3IsDisplay = true

				// 電話番号
				this.detail.tel1IsDisplay = true

				// 社員番号
				this.detail.synoIsDisplay = true

				// メールアドレス
				this.detail.emailIsDisplay = true

				// ＤＭ・メルマガ
				this.detail.dmkbIsDisplay = false

				// 備考
				this.detail.mem1IsDisplay = true

				UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeHealth End')
			},
			// 検査項目の受診区分(1:全員 2:一部)によってCSSクラス名を返す
			// 1:全員の場合は背景色を黄色にする
			getBackendColorInspectionJskb: function (jskb) {

				var resultClassName = ''

				// 背景色を黄色にするクラス名を返す
				if ('1' == jskb) {
					resultClassName = 'courseListKensa1'
				} else {
					resultClassName = 'courseListKensa0'
				}

				return resultClassName;
			},
			// 表示系--------------------------------------------------E
			// イベント系----------------------------------------------S
			// 更新ボタン押下時
			onUpdate: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onUpdate Start')

				// 予約状況変更確認モーダルを閉じる
				this.onChangeReserveInfoConfirmModalClose()
				// 予約状況変更処理中モーダルとしてモーダルを開く
				this.onChangeReserveInfoStartModalOpen()

				WIGA1DetailApi.Update({
					token: this.$store.state.auth.token,
					ukno: this.$store.state.adminUserChoice.MasterWIGA1.ukno,
					statusCode: this.inputForm.statusCode,
					isSendMail: this.inputForm.isSendMail,
					reserveDateYear: this.inputForm.reserveDateYear,
					reserveDateMonth: this.inputForm.reserveDateMonth,
					reserveDateDate: this.inputForm.reserveDateDate,
					reserveTmzn: this.inputForm.reserveTmzn
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// ストア値の更新
						this.$store.commit(
							types.ADMIN_USERCHOICE_WIGA1DETAIL_RESET)
						// 予約状況変更処理中モーダルのモーダルを閉じる
						this.onChangeReserveInfoStartModalClose()

						UtilityConsoleLog.consoleLog('WIGA1Detail::onUpdate End')

						// 予約状況編集 結果画面へ遷移する
						this.$router.push("/WIGA1Detail2")

					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1Detail::onUpdate End')
				})
			},
			// キャンセルボタン押下時
			onCancel: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onBack Start')

				// ストア値の更新
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIGA1DETAIL_RESET)
				// 受診者抽出画面へ遷移する
				this.$router.push("/WIGA1")

				UtilityConsoleLog.consoleLog('WIGA1Detail::onBack End')
			},
			// カレンダーボタン押下時
			onToCalender: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onBack Start')
				this.$router.push("/WIGA1DetailCalender")
				UtilityConsoleLog.consoleLog('WIGA1Detail::onBack End')
			},
			// イベント系----------------------------------------------E
			// 予約状況変更処理中モーダルとしてモーダルを開く
			onChangeReserveInfoStartModalOpen: function () {

				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoStartModalOpen Start')

				this.modalOpen('changeReserveInfoStart')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoStartModalOpen End')
			},
			// 予約状況変更処理中モーダルを閉じる
			onChangeReserveInfoStartModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoStartModalClose Start')

				this.modalClose('changeReserveInfoStart')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoStartModalClose End')
			},
			// 予約状況変更確認モーダルとしてモーダルを開く
			onChangeReserveInfoConfirmModalOpen: function () {

				UtilityConsoleLog.consoleLog('WIGA1Detail::onConfirmCancelModalOpen Start')

				this.modalOpen('changeReserveInfoConfirm')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onConfirmCancelModalOpen End')
			},
			// 予約状況変更確認モーダルを閉じる
			onChangeReserveInfoConfirmModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoConfirmModalClose Start')

				this.modalClose('changeReserveInfoConfirm')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onChangeReserveInfoConfirmModalClose End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]

				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('WIGA1Detail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1Detail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('WIGA1Detail::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {

				UtilityConsoleLog.consoleLog('WIGA1Detail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('WIGA1Detail::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {

				UtilityConsoleLog.consoleLog('WIGA1Detail::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('WIGA1Detail::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIGA1/WIGA1Detail.vue